import React from 'react';
import styled from 'styled-components';
import CellDiv from 'components/molecules/tables/components/CellDiv';

const StyledLogo = styled.img`
    max-width: 100%;
    border: none;
    ${props => !props.src && 'visibility: hidden'};
    object-fit: contain;
`;

const ImageContainer = styled(CellDiv)`
    display: flex;
    justify-content: center;
    height: 50px;
`;

const ImageCellDiv = ({ image }) => (
    <ImageContainer
        type={'text'}
        value={image && <StyledLogo src={image}/>}
    />
);

export default ImageCellDiv;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/components/ImageCellDiv.js